import styled from 'styled-components'

export const Wrapper = styled.div`
  max-width: 16rem;
  border: 1px solid var(--primary);
  border-radius: 0.3125rem;
`
